import React, { useState } from "react";
import routePaths from "../../routes/routePaths";
import { useTranslation, Trans } from "react-i18next";

const Banner = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { t } = useTranslation();

  return (
    <section className="relative h-[430px] md:h-[600px] w-full overflow-hidden">
      {/* Hình nền */}
      <img
        src="/banner.jpg"
        alt="Banner"
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
          isLoaded ? "opacity-100" : "opacity-0"
        }`}
        onLoad={() => setIsLoaded(true)}
      />

      {/* Lớp phủ gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-menu/80 to-primary/20" />

      {/* Nội dung hero */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4">
        <h1 className="text-3xl md:text-5xl font-extrabold leading-tight max-w-3xl text-white">
          {/* Sử dụng Trans để hỗ trợ HTML, highlight color */}
          <Trans
            i18nKey="banner.headline1"
            components={{
              1: <span className="text-secondary font-bold" />,
              2: <span className="text-primary" />
            }}
          />
        </h1>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a
            href={routePaths.contact}
            className="bg-primary text-white 
              font-bold 
              px-6 py-3 
              rounded 
              shadow-sm 
              hover:bg-secondary hover:text-menu 
              transition
              focus:outline-none focus:ring-2 focus:ring-primary/50
              active:scale-95"
          >
            {t("banner.trialBtn")}
          </a>
        </div>
      </div>

      {/* Fallback: nền màu khi ảnh chưa tải */}
      {!isLoaded && (
        <div className="absolute inset-0 bg-bg animate-pulse" />
      )}
    </section>
  );
};

export default Banner;
